<template>
  <component :is="homeComponent" :key="publicId" />
</template>

<script>
import { getShadowGameRoute } from "@/utils/shadowGameRoute";

export default {
  name: "Index",
  components: {
    CurrentIndex: () => import("./index.vue"),
    Archive19Index: () => import("./archive19/index.vue")
  },
  data() {
    return {
      publicId: getShadowGameRoute(this.$route.query.id).publicId
    };
  },
  watch: {
    $route(to) {
      if (to.name === "Index") {
        this.publicId = getShadowGameRoute(to.query.id).publicId;
      }
    }
  },
  computed: {
    gameRoute() {
      return getShadowGameRoute(this.publicId);
    },
    homeComponent() {
      return this.gameRoute.home === "archive19" ? "Archive19Index" : "CurrentIndex";
    }
  }
};
</script>
